import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import PartnerGuide from './index';

const PartnerGuideRoot = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route
          path={[
            '/practice/role_play_guides/:token',
            '/practice/preview/role_play_guides/:rolePlayId',
          ]}
          exact
          component={PartnerGuide}
        />
      </Switch>
    </BrowserRouter>
  );
};

export default PartnerGuideRoot;
